export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const AI_DOMAIN_URL = process.env.REACT_APP_AI_DOMAIN;
export const LOGO_URL = process.env.REACT_APP_LOGO_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
//  || 'https://plancrafter-ui.dreamztesting.com';
// 'https://www.plancrafter.tech';
export const DEFAULT_COUNTRY_ID = process.env.REACT_APP_DEFAULT_COUNTRY_ID || 4;
export const BBB_LOGO_URL = process.env.REACT_APP_BBB_LOGO_URL;
export const APP_NAME = process.env.REACT_APP_PROJECT_NAME;
export const STRIP_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const STRIP_SECRET_KEY = process.env.REACT_APP_STRIP_SECRET_KEY;
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || '';

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
export const RECAPTCHA_SECRET_KEY = process.env.REACT_APP_RECAPTCHA_SECRET_KEY || '';

export const APP_CURRENCY_CODE = process.env.REACT_APP_CURRENCY_CODE || 'CAD';

export const IMAGE_FETCH_BACKEND_URL = process.env.REACT_APP_IMAGE_FETCH_BACKEND_URL;
// console.log("SITE_URL", SITE_URL, DEFAULT_COUNTRY_ID, IMAGE_FETCH_BACKEND_URL)
// https://backend.plancrafter.tech
// 'https://plancrafter.dreamztesting.com';
// export const IMAGE_FETCH_BACKEND_URL = process.env.REACT_IMAGE_FETCH_BACKEND_URL || 'https://newlive-backend.plancrafter.tech/';